<template>
  <div class="container">
    <div class="row">
      <h3 class="mx-auto">Effectiveness Evaluation</h3>
    </div>
    <div class="row mx-auto" style="margin-bottom: -60px">
      <p style="font-size: 1.2em">
        Rate each behaviour and key effectiveness area using the scale below.
        Then, using the same scale, an overall effectiveness rating is giving at
        the end of the evaluation.
      </p>
    </div>
  <div class="sticky-top" style="padding-top: 60px; z-index:1;">
<div class="row mx-auto bg-white pt-3">
      <div class="col">
        <p class="max-auto text-center m-0"><strong>1</strong></p>
      </div>
      <div class="col">
        <p class="max-auto text-center m-0"><strong>2</strong></p>
      </div>
      <div class="col">
        <p class="max-auto text-center m-0"><strong>3</strong></p>
      </div>
      <div class="col">
        <p class="max-auto text-center m-0"><strong>4</strong></p>
      </div>
      <div class="col">
        <p class="max-auto text-center m-0"><strong>5</strong></p>
      </div>
    </div>
    <div class="row border-bottom mx-auto bg-white">
      <div class="col">
        <p class="max-auto text-center">Does not meet expectations</p>
      </div>
      <div class="col">
        <p class="max-auto text-center">Partially meets expectations</p>
      </div>
      <div class="col">
        <p class="max-auto text-center">Meets expectations</p>
      </div>
      <div class="col">
        <p class="max-auto text-center">Exceeds expectations</p>
      </div>
      <div class="col">
        <p class="max-auto text-center">Far exceeds expectations</p>
      </div>
    </div>
  </div>
    
    <b-form @submit="onSubmit">
      <div
        v-for="(category, category_index) in evaluation.categories"
        :key="category.index"
        class="m-5 border-bottom justify-content-center"
      >
        <h5>{{ category.title }}</h5>
        <evaluationQuestion
          v-for="(questions, index) in category.questions"
          :key="questions.index"
          @newdata="handleData($event, index, category_index)"
          :question="questions"
          :category="category"
        />
      </div>
      <div class="text-center">
        <b-button type="submit" variant="primary">Submit</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import evaluationQuestion from "@/components/engagement/forms/evaluationQuestion.vue";

export default {
  mixins: [],
  props: ["user"],
  components: {
    evaluationQuestion,
  },
  computed: {
    ...mapGetters("users", ["getClaims", "getMe"]),
    ...mapGetters("evaluation", ["getEvaluation"]),
  },
  data() {
    return {
      dbEvaluation: null,
      evaluation: {
        categories: [
          {
            category: "communication",
            title: "Communicates effectively",
            questions: [
              {
                question:
                  "Listens well and understands the needs of the company",
                name: "q1",
              },
              {
                question: "Expresses ideas clearly and directly",
                name: "q2",
              },
              {
                question: "Conveys confidence when communicating",
                name: "q3",
              },
              {
                question:
                  "Persuasively communicates in a way that produces positive results",
                name: "q4",
              },
            ],
          },
          {
            category: "relationships",
            title: "Develops relationships",
            questions: [
              {
                question: "Builds and sustains relationships to achieve goals",
                name: "q1",
              },
              {
                question:
                  "Collaborates effectively within and across departments",
                name: "q2",
              },
              {
                question: "Acknowledges the contributions of others",
                name: "q3",
              },
              {
                question: "Is an effective team member/leader",
                name: "q4",
              },
            ],
          },
          {
            category: "planning",
            title: "Plans effectively",
            questions: [
              {
                question: "Ensures work plans support department goals",
                name: "q1",
              },
              {
                question: "Helps efficient processes and work plans",
                name: "q2",
              },
              {
                question: "Anticipates problems and takes corrective actions",
                name: "q3",
              },
              {
                question:
                  "Effectively balances long-term and short-term priorities",
                name: "q4",
              },
            ],
          },
          {
            category: "results",
            title: "Makes results happen",
            questions: [
              {
                question: "Stays focused on satisfying the company",
                name: "q1",
              },
              {
                question:
                  "Keeps focused on results by clarifying process, roles, and responsibilities with others",
                name: "q2",
              },
              {
                question: "Makes sound, timely decisions that leads to results",
                name: "q3",
              },
              {
                question: "Takes personal responsibility for achieving results",
                name: "q4",
              },
            ],
          },
          {
            category: "resilience",
            title: "Demonstrates resilience and flexibility",
            questions: [
              {
                question:
                  "Deals effectively with multiple demands and shifting priorities",
                name: "q1",
              },
              {
                question:
                  "Shows resilience when faced with setbacks or criticism",
                name: "q2",
              },
              {
                question: "Is receptive to new ideas",
                name: "q3",
              },
              {
                question: "Actively supports organization change efforts",
                name: "q4",
              },
            ],
          },
          {
            category: "supporting",
            title: "Supports company values and policies",
            questions: [
              {
                question: "Practices and promotes the company's values",
                name: "q1",
              },
              {
                question: "Consistently follows the company's policies",
                name: "q2",
              },
              {
                question: "Acts honesly and ethically in the workplace",
                name: "q3",
              },
              {
                question: "Treats others in a fair and respectful manner",
                name: "q4",
              },
            ],
          },
          {
            category: "progression",
            title: "Develops self",
            questions: [
              {
                question: "Knows own strength and weaknesses",
                name: "q1",
              },
              {
                question: "Learns from experience",
                name: "q2",
              },
              {
                question: "Actively seeks feedback for improvement",
                name: "q3",
              },
              {
                question:
                  "Takes responsibility for completing development plan",
                name: "q4",
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    async getFirestoreEvaluation() {
      const where = [
        ["id", "==", this.$route.params.evaluationId],
        ["companyId", "==", this.getClaims.companyId],
      ];
      await this.$store
        .dispatch("evaluation/fetchAndAdd", {
          clauses: { where, limit: 1 },
        })
        .catch((e) => {});

      // uwes voor user inladen en berekenen
      this.dbEvaluation = await this.getEvaluation(
        this.$route.params.evaluationId
      );
      console.log(this.dbEvaluation);
    },

    handleData: function (e, q, c) {
      // console.log(e);
      // console.log(q);
      // console.log(c);
      // console.log(this.evaluation.categories[1])
      const questions = this.evaluation.categories[c].questions;
      questions.splice(q, 1, { ...questions[q], value: e });
      console.log(this.evaluation.categories[c].questions[q]);
    },
    async onSubmit(event) {
      event.preventDefault();
      this.dbEvaluation.answers.push(this.evaluation)
      this.dbEvaluation.assignedEvaluators.splice(this.dbEvaluation.assignedEvaluators.indexOf(this.getMe.id), 1)
      console.log('evaluationDB:', this.dbEvaluation)
      await this.$store.dispatch("evaluation/patch",{
        id: this.dbEvaluation.id,
        assignedEvaluators: this.dbEvaluation.assignedEvaluators,
        answers: this.dbEvaluation.answers
      })
      await this.swalToastSuccess(this.$t("ui.saved"));
      this.$router.push("/employeeprofile/" + this.getMe.id);
    },
  },
  async created() {
    this.getFirestoreEvaluation()
  },
};
</script>

<style scoped lang="scss">
// @import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>